import { useTranslation } from 'react-i18next';
import type { TripPhoto } from '../../../types';
import { tripPhotoUrl } from '../../../utils/tripPhotos';

const SHOWN = 4;

interface Props {
  photos: TripPhoto[];
  onOpen: (index: number) => void;
}

/** The photos taken at a stop (ADR-0042), under its card in the itinerary. */
export function StopPhotoStrip({ photos, onOpen }: Props) {
  const { t } = useTranslation();
  if (photos.length === 0) return null;
  const shown = photos.slice(0, SHOWN);
  const more = photos.length - shown.length;

  return (
    <div className="flex gap-1.5 pt-2 pl-3" aria-label={t('itinerary.stopPhotos', { count: photos.length })}>
      {shown.map((photo, i) => (
        <button
          key={photo.id}
          type="button"
          onClick={() => onOpen(i)}
          className="relative w-12 h-12 rounded-lg overflow-hidden bg-slate-100 dark:bg-slate-800 cursor-pointer shrink-0"
        >
          <img
            src={tripPhotoUrl(photo.thumbnailFilename ?? photo.filename)}
            alt={photo.originalName}
            loading="lazy"
            className="w-full h-full object-cover"
          />
          {more > 0 && i === shown.length - 1 && (
            <span className="absolute inset-0 flex items-center justify-center bg-black/50 text-white text-xs font-semibold">
              +{more}
            </span>
          )}
        </button>
      ))}
    </div>
  );
}
